import { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormOwnerEdit, { FORM_OWNER_EDIT_ID } from '../forms/FormOwnerEdit';
import { useTranslation } from 'react-i18next';

export default function SheetOwnerEdit({ open, onOpenChange, owner, onSubmit, isSubmitting }) {
    const { t } = useTranslation();
    const [resetKey, setResetKey] = useState(0);

    const handleOpenChange = (isOpen) => {
        if (isOpen) setResetKey((k) => k + 1);
        onOpenChange(isOpen);
    };

    return (
        <Sheet open={open} onOpenChange={handleOpenChange}>
            <SheetContent
                className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0 gap-0"
                showCloseButton={false}
            >
                <SheetHeader className="p-5 border-b border-border flex-shrink-0">
                    <SheetTitle className="text-[18px] text-foreground">{t('subsidiary:modifierLeParticulier')}</SheetTitle>
                </SheetHeader>

                <FormOwnerEdit key={resetKey} owner={owner} onSubmit={onSubmit} />

                <SheetFooter className="p-5 border-t border-border flex-shrink-0 flex gap-3">
                    <Button
                        type="button"
                        variant="soft"
                        color="neutral"
                        onClick={() => onOpenChange(false)}
                        className="flex-1 rounded-xl py-3 h-auto text-[14px]"
                    >
                        {t('subsidiary:annuler')}
                    </Button>
                    <SubmitButton
                        isSubmitting={isSubmitting}
                        loadingText={t('subsidiary:enregistrement')}
                        form={FORM_OWNER_EDIT_ID}
                        className="flex-1 text-foreground rounded-xl py-3 h-auto text-[14px]"
                    >
                        {t('subsidiary:enregistrer')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
